import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { QUICK_DEPOSIT_NAMESPACE } from '../store/modules/quick-deposit/quick-deposit.constants.js';
import '../store/modules/quick-deposit/quick-deposit.store.js';
import { store } from '../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const quickDepositModule = namespace(QUICK_DEPOSIT_NAMESPACE);
let SavedCardsMixin = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isLoading = true;
  }
  created() {
    return __async(this, null, function* () {
      yield this.initSavedCards();
      this.isLoading = false;
    });
  }
  get hasSavedCards() {
    return this.savedCards.length > 0;
  }
  get isLoadingCards() {
    return this.isLoading;
  }
};
__decorateClass([
  quickDepositModule.Getter("savedCards")
], SavedCardsMixin.prototype, "savedCards", 2);
__decorateClass([
  quickDepositModule.Action("initSavedCards")
], SavedCardsMixin.prototype, "initSavedCards", 2);
SavedCardsMixin = __decorateClass([
  Component({
    store,
    name: "saved-cards-mixin"
  })
], SavedCardsMixin);

export default SavedCardsMixin;
